<p-dialog
  [(visible)]="dialogVisible"
  [header]="'forms.descriptions.entities' | transloco"
  [style]="{width: '90vw'}"
  [draggable]="false"
  [resizable]="true"
  [modal]="true"
  (visibleChange)="visibleChange.emit($event)"
  (close)="this.selected = providedSelection"
  [styleClass]="'custom-p-dialog'"
>
  <div class="flex flex-column justify-content-between">
    <div class="flex flex-column">
      <div class="grid">
        <div class="col-6 flex flex-column">
          <div class="card main-height">
            <div class="card-header pt-1"><h4 class="mb-1">{{'model.sensors' | transloco}} </h4></div>
            <hr>
            <div class="flex">
              <div class="col-12 md:col-12 lg:col-6 xl:col-4">
                <div class="col-12 form-field">
                  <label for="name">{{'attribute.sensor' | transloco}}</label>
                </div>
                <div class="col-12 form-field">
                  <input
                    [(ngModel)]="measurementFilters.name"
                    (keyup.enter)="applyMeasurementFilters()"
                    pInputText
                    appAutoFocus
                    class="w-full"
                    id="name"
                    type="text"
                  >
                </div>
              </div>
              <div class="col-12 md:col-12 lg:col-6 xl:col-4">
                <div class="col-12 form-field">
                  <label for="measurementUnit">{{'model.measurementUnit' | transloco}}</label>
                </div>
                <div class="col-12">
                  <p-multiSelect
                    [(ngModel)]="measurementFilters.measurementTypeUnits"
                    [placeholder]="'select.generic' | transloco"
                    [options]="measurementUnits"
                    [filter]="true"
                    [styleClass]="'w-full'"
                    id="measurementUnit"
                    optionLabel="value"
                    optionValue="value"
                    filterBy="value"
                    display="chip"
                    appendTo="body"
                  ></p-multiSelect>
                </div>
              </div>
              <div class="col-12 md:col-12 lg:col-6 xl:col-4">
                <div class="search-div-button">
                  <button
                    [label]="'common.search' | transloco"
                    (click)="applyMeasurementFilters()"
                    pButton
                    icon="pi pi-search"
                    iconPos="right"
                  ></button>
                </div>
              </div>
            </div>
            <p-table
              [(first)]="measurementsFirst"
              [(rows)]="measurementsRows"
              [(selection)]="selectedMeasurement"
              (selectionChange)="onMeasurementSelect($event)"
              [value]="measurements"
              [totalRecords]="totalMeasurements"
              [lazy]="true"
              (onLazyLoad)="onMeasurementsPageChange($event)"
              [paginator]="true"
              [autoLayout]="true"
              [sortField]="measurementFilters.sortField"
              [style]="{minHeight: '308px'}"
              selectionMode="single"
              dataKey="id"
              responsiveLayout="stack"
            >
              <ng-template pTemplate="header">
                <tr>
                  <th pSortableColumn="name">
                    {{'attribute.measurementName' | transloco}}
                    <p-sortIcon field="name"></p-sortIcon>
                  </th>
                  <th pSortableColumn="measurementTypeUnit">
                    {{'model.measurementUnit' | transloco}}
                    <p-sortIcon field="measurementTypeUnit"></p-sortIcon>
                  </th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-measurement>
                <ng-component *ngIf="!hasBeenOpened || loadingMeasurements then skeletonRow else dataRow"></ng-component>
                <ng-template #dataRow>
                  <tr [pSelectableRow]="measurement">
                    <td class="h-3rem py-0">
                      <span class="p-column-title bold">{{'attribute.measurementName' | transloco}}</span>
                      <p class="text-right md:text-left">{{measurement.name}}</p>
                    </td>
                    <td class="h-3rem py-0">
                      <span class="p-column-title bold">{{'model.measurementUnit' | transloco}}</span>
                      <p class="text-right md:text-left">{{measurement.measurementTypeUnit ?? '-'}}</p>
                    </td>
                  </tr>
                </ng-template>
                <ng-template #skeletonRow>
                  <tr>
                    <td class="h-3rem py-0"><p-skeleton height="1em"></p-skeleton></td>
                    <td class="h-3rem py-0"><p-skeleton height="1em"></p-skeleton></td>
                  </tr>
                </ng-template>
              </ng-template>
              <ng-template pTemplate="summary">
                <div class="flex align-items-center justify-content-between" *ngIf="totalMeasurements > 0">
                  {{'pagination.showing' | transloco}} {{measurementsFirst + 1}}
                  {{'pagination.to' | transloco}} {{(measurementsFirst + measurementsRows) >= totalMeasurements ? totalMeasurements : (measurementsFirst + measurementsRows)}}
                  {{'pagination.of' | transloco}} {{totalMeasurements}}
                  {{(totalMeasurements > 1 ? 'pagination.entries' : 'pagination.entry') | transloco}}
                </div>
                <div class="flex align-items-center justify-content-between"
                     *ngIf="totalMeasurements == 0">{{'empty.measurementsTenant' | transloco}}</div>
              </ng-template>
            </p-table>
          </div>
        </div>
        <div class="col-6 flex flex-column">
          <div class="card main-height">
            <div class="card-header pt-1"><h4 class="mb-1">{{'model.entities' | transloco}} </h4></div>
            <hr>
            <div class="flex">
              <div class="col-12 md:col-12 lg:col-6 xl:col-4">
                <div class="col-12 form-field">
                  <label for="identifier">{{'model.entity' | transloco}}</label>
                </div>
                <div class="col-12 form-field">
                  <input
                    [(ngModel)]="entityFilters.identifier"
                    (keyup.enter)="applyEntityFilters()"
                    pInputText
                    appAutoFocus
                    class="w-full"
                    id="identifier"
                    type="text"
                  >
                </div>
              </div>
              <div class="col-12 md:col-12 lg:col-6 xl:col-4">
                <div class="col-12 form-field">
                  <label for="entityType">{{'attribute.entityType' | transloco}}</label>
                </div>
                <div class="col-12">
                  <p-multiSelect
                    [(ngModel)]="entityFilters.entityType"
                    [placeholder]="'select.generic' | transloco"
                    [options]="entityTypes"
                    [filter]="true"
                    [styleClass]="'w-full'"
                    inputId="category"
                    optionLabel="label"
                    optionValue="value"
                    filterBy="value"
                    display="chip"
                    appendTo="body"
                    id="entityType"
                  ></p-multiSelect>
                </div>
              </div>
              <div class="col-12 md:col-12 lg:col-6 xl:col-4">
                <div class="search-div-button">
                  <button
                    [label]="'common.search' | transloco"
                    (click)="applyEntityFilters()"
                    pButton
                    icon="pi pi-search"
                    iconPos="right"
                  ></button>
                </div>
              </div>
            </div>
            <div *ngIf="selectedMeasurement else selectMeasurementMessage">
              <p-table
                [(first)]="entitiesFirst"
                [(rows)]="entitiesRows"
                [value]="entities"
                [totalRecords]="totalEntities"
                [lazy]="true"
                (onLazyLoad)="onEntitiesPageChange($event)"
                [paginator]="true"
                [autoLayout]="true"
                [sortField]="entityFilters.sortField"
                [style]="{minHeight: '308px'}"
                responsiveLayout="stack"
              >
                <ng-template pTemplate="header">
                  <tr>
                    <th class="selection-column-width"></th>
                    <th pSortableColumn="identifier">
                      {{'attribute.serialNumber' | transloco}}/{{'attribute.alias' | transloco}}
                      <p-sortIcon field="identifier"></p-sortIcon>
                    </th>
                    <th pSortableColumn="entityType">
                      {{'attribute.entityType' | transloco}}
                      <p-sortIcon field="entityType"></p-sortIcon>
                    </th>
                  </tr>
                </ng-template>
                <ng-template pTemplate="body" let-entity>
                  <ng-component *ngIf="!hasBeenOpened || loadingEntities then skeletonRow else dataRow"></ng-component>
                  <ng-template #dataRow>
                    <tr [style.backgroundColor]="isEntitySelected(entity) ? '#FBFAFA' : null">
                      <td class="h-3rem py-0">
                        <span class="p-column-title bold">{{'common.select' | transloco}}</span>
                        <button
                          *ngIf="!isEntitySelected(entity)"
                          (click)="selectEntity(entity)"
                          pButton
                          class="p-button-icon-only p-button-text"
                          icon="pi pi-plus"
                        ></button>
                        <button
                          *ngIf="isEntitySelected(entity)"
                          (click)="deselectEntity(entity)"
                          pButton
                          class="p-button-icon-only p-button-text"
                          icon="pi pi-minus"
                        ></button>
                      </td>
                      <td class="h-3rem py-0">
                        <span class="p-column-title bold">{{'attribute.serialNumber' | transloco}}/{{'attribute.alias' | transloco}}</span>
                        <p class="text-right md:text-left">{{entity.identifier}}</p>
                      </td>
                      <td class="h-3rem py-0">
                        <span class="p-column-title bold">{{'attribute.entityType' | transloco}}</span>
                        <p *ngIf="entity.entityType === 'DEVICE'" class="text-right md:text-left">{{'model.device' | transloco}}</p>
                        <p *ngIf="entity.entityType === 'ASSET'" class="text-right md:text-left">{{'model.asset' | transloco}}</p>
                      </td>
                    </tr>
                  </ng-template>
                  <ng-template #skeletonRow>
                    <tr>
                      <td class="h-3rem py-0"><p-skeleton height="1em"></p-skeleton></td>
                      <td class="h-3rem py-0"><p-skeleton height="1em"></p-skeleton></td>
                      <td class="h-3rem py-0"><p-skeleton height="1em"></p-skeleton></td>
                    </tr>
                  </ng-template>
                </ng-template>
                <ng-template pTemplate="summary">
                  <div class="flex align-items-center justify-content-between" *ngIf="totalEntities > 0">
                    {{'pagination.showing' | transloco}} {{entitiesFirst + 1}}
                    {{'pagination.to' | transloco}} {{(entitiesFirst + entitiesRows) >= totalEntities ? totalEntities : (entitiesFirst + entitiesRows)}}
                    {{'pagination.of' | transloco}} {{totalEntities}}
                    {{(totalEntities > 1 ? 'pagination.entries' : 'pagination.entry') | transloco}}
                  </div>
                  <div class="flex align-items-center justify-content-between"
                       *ngIf="totalEntities == 0">{{'empty.entitiesOrganization' | transloco}}</div>
                </ng-template>
              </p-table>
            </div>
          </div>
        </div>
      </div>

      <div class="card main-height" style="margin: 8px 0px">
        <div class="card-header pt-1"><h4 class="mb-1">{{'misc.entitiesSelected' | transloco}} </h4></div>
        <hr>
        <p-table
          [(first)]="selectedFirst"
          [(rows)]="selectedRows"
          [value]="selected"
          [totalRecords]="selected.length"
          [paginator]="true"
          [autoLayout]="true"
          responsiveLayout="stack"
          styleClass="fade-in"
        >
          <ng-template pTemplate="header">
            <tr>
              <th class="selection-column-width"></th>
              <th pSortableColumn="name">
                {{'attribute.measurementName' | transloco}}
                <p-sortIcon field="name"></p-sortIcon>
              </th>
              <th pSortableColumn="measurementTypeUnit">
                {{'model.measurementUnit' | transloco}}
                <p-sortIcon field="measurementTypeUnit"></p-sortIcon>
              </th>
              <th pSortableColumn="identifier">
                {{'attribute.serialNumber' | transloco}}/{{'attribute.alias' | transloco}}
                <p-sortIcon field="identifier"></p-sortIcon>
              </th>
              <th pSortableColumn="entityType">
                {{'attribute.entityType' | transloco}}
                <p-sortIcon field="entityType"></p-sortIcon>
              </th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-entity>
            <tr>
              <td class="h-3rem py-0">
                <span class="p-column-title bold">{{'common.select' | transloco}}</span>
                <button
                  (click)="deselectEntity(entity)"
                  pButton
                  class="p-button-icon-only p-button-text"
                  icon="pi pi-minus"
                ></button>
              </td>
              <td class="h-3rem py-0">
                <span class="p-column-title bold">{{'attribute.measurementName' | transloco}}</span>
                <p class="text-right md:text-left">{{entity.measurementName}}</p>
              </td>
              <td class="h-3rem py-0">
                <span class="p-column-title bold">{{'model.measurementUnit' | transloco}}</span>
                <p class="text-right md:text-left">{{entity.measurementTypeUnit ?? '-'}}</p>
              </td>

              <td class="h-3rem py-0">
                <span class="p-column-title bold">{{'attribute.serialNumber' | transloco}}/{{'attribute.alias' | transloco}}</span>
                <p class="text-right md:text-left">{{entity.identifier}}</p>
              </td>
              <td class="h-3rem py-0">
                <span class="p-column-title bold">{{'attribute.entityType' | transloco}}</span>
                <p *ngIf="entity.entityType === 'DEVICE'" class="text-right md:text-left">{{'model.device' | transloco}}</p>
                <p *ngIf="entity.entityType === 'ASSET'" class="text-right md:text-left">{{'model.asset' | transloco}}</p>
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr>
              <td colspan="6">
                <div class="flex justify-content-center">
                  <p class="text-lg">
                    {{'misc.addEntitiesToContinue' | transloco}}
                  </p>
                </div>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
    <div class="flex justify-content-between mt-2">
      <button
        [label]="'common.cancel' | transloco"
        (click)="visibleChange.emit(false);"
        class="p-button-danger"
        pButton
      ></button>
      <button
        [label]="'common.save' | transloco"
        [disabled]="selected.length == 0"
        (click)="selectedEntitiesChange.emit(selected); visibleChange.emit(false)"
        pButton
      ></button>
    </div>
  </div>
</p-dialog>
<ng-template #selectMeasurementMessage>
  <div class="flex justify-content-center align-items-center mt-8">
    <p class="text-2xl">
      {{'select.entityMeasurement' | transloco}}
    </p>
  </div>
</ng-template>
